import { render, staticRenderFns } from "./variables.vue?vue&type=template&id=8b010342&"
import script from "./variables.vue?vue&type=script&lang=js&"
export * from "./variables.vue?vue&type=script&lang=js&"
import style0 from "./variables.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports